import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

type TranslationResponse = TranslationObject | { data: TranslationObject };

function isWrappedTranslationResponse(
  response: TranslationResponse,
): response is { data: TranslationObject } {
  return (
    'data' in response &&
    typeof response.data === 'object' &&
    response.data !== null &&
    !Array.isArray(response.data)
  );
}

@Injectable()
export class ApiTranslateLoader extends TranslateLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http
      .get<TranslationResponse>(
        `${environment.apiUrl}/driver/registration/translations?lang=${encodeURIComponent(lang)}`,
      )
      .pipe(map((response) => (isWrappedTranslationResponse(response) ? response.data : response)));
  }
}
